import styled from 'styled-components';

export const Content = styled.div`
  position: relative;
  margin-left: 20px;
  min-width: 600px;
  height: auto;
  flex-grow: 1;
  border-radius: 4px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.5);
`;

export const Interface = styled.div`
  position: relative;
  width: 100%;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border: solid 10px ${(props) => props.color};
  min-height: 500px;
`;

export const Wrapper = styled.div`
  padding: 25px 0 90px 18px;
  width: 460px;
  max-width: 100%;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 50px 130px 130px;
  justify-content: space-between;
  column-gap: 20px;
  align-items: center;
  min-height: 40px;
  margin: 0 0 12px;
  color: var(--cp-text, #fff);
  &.toggle {
    display: flex;
    justify-content: space-between;
    gap: 20px;
  }
`;

export const RowLabel = styled.div`
  font-size: 16px;
  white-space: nowrap;
  line-height: 1.2;
`;

export const ToggleCell = styled.div`
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  & > div {
    height: 28px;
  }
  label {
    margin: 0;
  }
`;

export const Divider = styled.div`
  height: 1px;
  margin: 15px 0 20px;
  background-color: var(--cp-border, rgba(255, 255, 255, 0.3));
`;

export const HeaderCell = styled.div`
  font-size: 14px;
  opacity: 0.8;
  color: var(--cp-text, #fff);
  &.right {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

export const FieldCell = styled.div`
  min-width: 0;
`;
